<template>
    <div class="step-navigation">
        <p v-if="error">{{ error }}</p>
        <button @click="toggleNextStep" type="submit" class="step-navigation__button">
            {{ label }}
        </button>
    </div>
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex';

    export default {
        props: {
            label: {
                type: String,
                default: 'Next',
                required: false,
            },

            v: {
                type: Object,
                required: true,
            }
        },

        data() {
            return {
                error: null,
            }
        },

        methods: {
            /**
             * Toggles next step
             * */
            toggleNextStep() {
                const nextStepId = this.currentStepId + 1;

                this.v.$touch();

                if (this.v.$invalid) {
                    this.error = 'Please fill required fields above.';
                } else {
                    this.toggleStep(nextStepId);
                }
            },

            ...mapMutations('stepProgress', [
                'toggleStep',
            ]),
        },

        computed: {
            ...mapGetters('stepProgress', [
                'currentStepId'
            ]),
        }
    }
</script> 